module.exports = __webpack_public_path__ + "assets/img/支持自主开发更新.495e0084.jpg";